module.exports = {
	"auth0": {
		"clientID": "WObiWvVcGqx9DF2HDH1z5YPDV9HJCQm0",
		"domain": "gsmarketing.auth0.com"
	},
	"osprey": {
		"api": "https://api.gsm.auto/v1",
		"help": "https://help.gsm.auto"
	},
	"self": {
		"host": "atom.gsm.auto"
	},
	"environment": "production"
};


//////////////////
// WEBPACK FOOTER
// ./src/include/site.config.json
// module id = 157
// module chunks = 51